import { useQuery } from '@tanstack/react-query'
import moment from 'moment'

import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { getWarehousesEndpoint } from 'repositories/BerthApi/getWarehouses/endpoint'
import type { GetWarehousesResponse, Warehouse } from 'repositories/BerthApi/getWarehouses/type'
import { warehouseKeys } from 'repositories/queryKeys'

export type UseWarehousesQueryReturn = {
  warehouseList: Warehouse[]
}

// 倉庫一覧（テナント含む）を取得する共通 Query hook。
// 一覧ヘッダー（useWarehouseSelection）と詳細ヘッダー（useSelectedWarehouseTenantNames）が
// 同一の queryKey / エンドポイント / booking_date で共有するため、クエリ定義をここに集約する。
// 同一 QueryClient 配下では両者でキャッシュが共有される。
export const useWarehousesQuery = (): UseWarehousesQueryReturn => {
  const bookingDate = moment().format('YYYY-MM-DD')

  const { data } = useQuery({
    queryKey: warehouseKeys.list(bookingDate),
    queryFn: () =>
      fetcher<GetWarehousesResponse>(`${getWarehousesEndpoint}?booking_date=${bookingDate}`),
  })

  return { warehouseList: data?.data ?? [] }
}
